import { defaultToggles } from 'context/FeatureTogglesProvider';
import { api, logger } from 'utils';

export interface FeatureTogglesResponse {
  [key: string]: string | number | boolean;
}

async function getLocalToggles() {
  const { default: data } = await import('../../featureToggles.local.json');
  return data;
}

export default class FeatureTogglesService {
  private adapter: api.Adapter;

  constructor() {
    this.adapter = new api.Adapter({
      baseURL: process.env.REACT_APP_BASENAME,
      responseType: 'json'
    });
  }

  async getToggles(): Promise<FeatureTogglesResponse> {
    // Serve feature toggles from local file when developing locally
    if (process.env.REACT_APP_STAGE === 'local') {
      return await getLocalToggles();
    }
    try {
      const { data } = await this.adapter.getValue<FeatureTogglesResponse>(
        '/static/featureToggles.json'
      );
      return data;
    } catch (e) {
      logger.error('Get toggles error', e);
      // Return default toggles if request fails
      return defaultToggles;
    }
  }
}
